import ContainedMenuButton from './contained-menu-button-view'

export default ContainedMenuButton
